import { createAPIModule } from '@/api/utils';

export default createAPIModule({
  endpoint: 'codigos-postales',
  getAllParams: ({
    sort,
    from, include, page, perPage, codigopostal, municipio, to, zonas,
  }) => ({
    'filter[codigopostal]': codigopostal,
    'filter[municipio]': municipio,
    'filter[zonas_id]': zonas,
    from,
    // include,
    page,
    per_page: perPage,
    to,
    sort,
  }),
});
